import { render, staticRenderFns } from "./company_profile.vue?vue&type=template&id=21076d44&"
import script from "./company_profile.vue?vue&type=script&lang=js&"
export * from "./company_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports